// import styled, { css } from 'styled-components';

// *************************************
// MATERIAL-UI ICONS                              
// *************************************
import MuiAddIcon from '@material-ui/icons/AddRounded';
import MuiAppsIcon from '@material-ui/icons/AppsRounded';
import MuiArrowBackIcon from '@material-ui/icons/ArrowBackRounded';
import MuiArrowDropDownIcon from '@material-ui/icons/ArrowDropDownRounded';
import MuiArrowDownIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import MuiArrowDownwardIcon from '@material-ui/icons/ArrowDownwardRounded';
import MuiArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeftRounded';
import MuiArrowRightIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import MuiArrowUpIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MuiArrowUpwardIcon from '@material-ui/icons/ArrowUpwardRounded';
import MuiAttachFileIcon from '@material-ui/icons/AttachFileRounded';
import MuiAspectRatioIcon from '@material-ui/icons/AspectRatioRounded';
import MuiAudioTrackIcon from '@material-ui/icons/AudiotrackRounded';
import MuiBlockIcon from '@material-ui/icons/BlockRounded';
import MuiBookmarkIcon from '@material-ui/icons/BookmarkRounded';
import MuiCheckIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import MuiCloseIcon from '@material-ui/icons/CloseRounded';
import MuiCommentIcon from '@material-ui/icons/ChatBubbleRounded';
import MuiDateIcon from '@material-ui/icons/EventRounded';
import MuiDateCheckIcon from '@material-ui/icons/EventAvailableRounded';
import MuiDateRangeIcon from '@material-ui/icons/DateRange';
import MuiDeleteIcon from '@material-ui/icons/DeleteRounded';
import MuiEditIcon from '@material-ui/icons/EditRounded';
import MuiEmailIcon from '@material-ui/icons/EmailRounded';
import MuiEmailOutlineIcon from '@material-ui/icons/MailOutlineRounded';
import MuiErrorIcon from '@material-ui/icons/ErrorOutlineRounded';
import MuiExitToAppIcon from '@material-ui/icons/ExitToAppRounded';
import MuiFacebookIcon from '@material-ui/icons/Facebook';
import MuiFilterListIcon from '@material-ui/icons/FilterListRounded';
import MuiDescriptionIcon from '@material-ui/icons/DescriptionRounded';
import MuiGetAppIcon from '@material-ui/icons/GetAppRounded';
import MuiHelpIcon from '@material-ui/icons/HelpOutlineRounded';
import MuiHomeIcon from '@material-ui/icons/HomeRounded';
import MuiImportExportIcon from '@material-ui/icons/ImportExportRounded';
import MuiInfoIcon from '@material-ui/icons/InfoOutlined';
import MuiInstagramIcon from '@material-ui/icons/Instagram';
import MuiLabelIcon from '@material-ui/icons/LabelRounded';
import MuiLabelOffIcon from '@material-ui/icons/LabelOffRounded';
import MuiLabelOutlineIcon from '@material-ui/icons/LabelOutlined';
import MuiLabelOffOutlineIcon from '@material-ui/icons/LabelOffOutlined';
import MuiLinkedInIcon from '@material-ui/icons/LinkedIn';
import MuiLockIcon from '@material-ui/icons/LockRounded';
import MuiMenuIcon from '@material-ui/icons/MenuRounded';
import MuiMoreIcon from '@material-ui/icons/MoreRounded';
import MuiMoreHorizIcon from '@material-ui/icons/MoreHorizRounded';
import MuiMoreVertIcon from '@material-ui/icons/MoreVertRounded';
import MuiNotificationsIcon from '@material-ui/icons/NotificationsRounded';
import MuiNotificationsOutlineIcon from '@material-ui/icons/NotificationsNoneRounded';
import MuiPersonIcon from '@material-ui/icons/PersonRounded';
import MuiPhoneIcon from '@material-ui/icons/PhoneRounded';
import MuiRadioUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import MuiRemoveIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import MuiSearchIcon from '@material-ui/icons/SearchRounded';
import MuiSettingsIcon from '@material-ui/icons/SettingsRounded';
import MuiSortIcon from '@material-ui/icons/SortRounded';
import MuiStarRoundedIcon from '@material-ui/icons/StarRounded';
import MuiUndoIcon from '@material-ui/icons/UndoRounded';
import MuiTheatersIcon from '@material-ui/icons/TheatersRounded';
import MuiTimeIcon from '@material-ui/icons/AccessTimeRounded';
import MuiTranslateIcon from '@material-ui/icons/TranslateRounded';
import MuiTwitterIcon from '@material-ui/icons/Twitter';
import MuiVisibilityIcon from '@material-ui/icons/VisibilityRounded';
import MuiVisibilityOffIcon from '@material-ui/icons/VisibilityOffRounded';
import MuiWarnIcon from '@material-ui/icons/ReportProblemOutlined';
import MuiYouTubeIcon from '@material-ui/icons/YouTube';

// *************************************
// MATERIAL DESIGN ICONS                              
// *************************************

// import MdiBookmarkOffIcon from 'mdi-material-ui/BookmarkOffOutline';
// // import MdiBookmarkPlusIcon from 'mdi-material-ui/BookPlus';
// import MdiCheckboxBlankOffOutlineIcon from 'mdi-material-ui/CheckboxBlankOffOutline';
// import MdiCircleIcon from 'mdi-material-ui/Circle';
// import MdiEmailOffOutlineIcon from 'mdi-material-ui/EmailOffOutline';
// import MdiFileCSVIcon from 'mdi-material-ui/FileDelimited';
// import MdiFileExcelIcon from 'mdi-material-ui/FileExcel';
// import MdiFilePDFIcon from 'mdi-material-ui/FilePdfBox';
// import MdiFilePowerpointIcon from 'mdi-material-ui/FilePowerpoint';
// import MdiFileWordIcon from 'mdi-material-ui/FileWord';
// import MdiLockQuestionIcon from 'mdi-material-ui/LockQuestion';
// import MdiNotificationsOffOutlineIcon from 'mdi-material-ui/BellOffOutline';

// *************************************
// TABLER ICONS                              
// *************************************
/*
import { IconArcheryArrow } from '@tabler/icons-react';
import { IconArrowNarrowDown } from '@tabler/icons-react';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { IconArrowNarrowRight } from '@tabler/icons-react';
import { IconArrowNarrowUp } from '@tabler/icons-react';
import { IconCalendarDown } from '@tabler/icons-react';
import { IconCalendarUp } from '@tabler/icons-react';
import { IconCalendarShare } from '@tabler/icons-react';
import { IconCalendarX } from '@tabler/icons-react';
import { IconCopy } from '@tabler/icons-react';
import { IconCopyOff } from '@tabler/icons-react';
import { IconClockCancel } from '@tabler/icons-react';
import { IconFolder } from '@tabler/icons-react';
import { IconFolders } from '@tabler/icons-react';
import { IconFolderBolt } from '@tabler/icons-react';
import { IconFolderCancel } from '@tabler/icons-react';
import { IconFolderCheck } from '@tabler/icons-react';
import { IconFolderCode } from '@tabler/icons-react';
import { IconFolderCog } from '@tabler/icons-react';
import { IconFolderDown } from '@tabler/icons-react';
import { IconFolderExclamation } from '@tabler/icons-react';
import { IconFolderHeart } from '@tabler/icons-react';
import { IconFolderMinus } from '@tabler/icons-react';
import { IconFolderOff } from '@tabler/icons-react';
import { IconFolderOpen } from '@tabler/icons-react';
import { IconFolderPause } from '@tabler/icons-react';
import { IconFolderPlus } from '@tabler/icons-react';
import { IconFolderSearch } from '@tabler/icons-react';
import { IconFolderShare } from '@tabler/icons-react';
import { IconFolderStar } from '@tabler/icons-react';
import { IconFolderUp } from '@tabler/icons-react';
import { IconFolderX } from '@tabler/icons-react';
import { IconGavel } from '@tabler/icons-react';
import { IconHistory } from '@tabler/icons-react';
import { IconHourglassLow } from '@tabler/icons-react';
import { IconPin } from '@tabler/icons-react';
import { IconPinned } from '@tabler/icons-react';
import { IconPinnedOff } from '@tabler/icons-react';
import { IconSquare } from '@tabler/icons-react';
import { IconSwitchHorizontal } from '@tabler/icons-react';
import { IconSwitchVertical } from '@tabler/icons-react';
*/

// *************************************
// ICONSAX ICONS                              
// *************************************
// import { ExportCircle as IconsaxExportCircle } from 'iconsax-react';
// import { ImportCircle as IconsaxImportCircle } from 'iconsax-react';

// *************************************
// STYLED COMPONENTS                               
// *************************************

// const Styled = {};

// // Iconsax Default Styles
// const IconsaxStyles = css`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   & > path {
//     stroke-width: ${(props) => (props.size <= 20) && '2.2px'};
//     stroke-width: ${(props) => (props.size > 20 && props.size <= 35) && '2px'};
//     stroke-width: ${(props) => (props.size > 35) && '1.8px'};
//   }
//   & > g > path {
//     stroke-width: ${(props) => (props.size <= 20) && '2.2px'};
//     stroke-width: ${(props) => (props.size > 20 && props.size <= 35) && '2px'};
//     stroke-width: ${(props) => (props.size > 35) && '1.8px'};
//   }
// `;

// Styled.ExportCircle = styled(IconsaxExportCircle)`${IconsaxStyles}`;
// Styled.ImportCircle = styled(IconsaxImportCircle)`${IconsaxStyles}`;

export const Icons = {
  Add: MuiAddIcon,
  Apps: MuiAppsIcon,
  // ArcheryArrow: IconArcheryArrow,
  ArrowBack: MuiArrowBackIcon,
  ArrowDropDown: MuiArrowDropDownIcon,
  ArrowDown: MuiArrowDownIcon,
  ArrowDownward: MuiArrowDownwardIcon,
  ArrowLeft: MuiArrowLeftIcon,
  ArrowRight: MuiArrowRightIcon,
  ArrowUp: MuiArrowUpIcon,
  ArrowUpward: MuiArrowUpwardIcon,
  // ArrowNarrowDown: IconArrowNarrowDown,
  // ArrowNarrowLeft: IconArrowNarrowLeft,
  // ArrowNarrowRight: IconArrowNarrowRight,
  // ArrowNarrowUp: IconArrowNarrowUp,
  AttachFile: MuiAttachFileIcon,
  AudioTrack: MuiAudioTrackIcon,
  AspectRatio: MuiAspectRatioIcon,
  Block: MuiBlockIcon,
  Bookmark: MuiBookmarkIcon,
  // BookmarkOff: MdiBookmarkOffIcon,
  // BookmarkPlus: MdiBookmarkPlusIcon,
  // CalendarDown: IconCalendarDown,
  // CalendarUp: IconCalendarUp,
  // CalendarShare: IconCalendarShare,
  // CalendarX: IconCalendarX,
  Check: MuiCheckIcon,
  // CheckboxOff: MdiCheckboxBlankOffOutlineIcon,
  // ClockCancel: IconClockCancel,
  Close: MuiCloseIcon,
  // Circle: MdiCircleIcon,
  Comment: MuiCommentIcon,
  // Copy: IconCopy,
  // CopyOff: IconCopyOff,
  Date: MuiDateIcon,
  DateCheck: MuiDateCheckIcon,
  DateRange: MuiDateRangeIcon,
  Delete: MuiDeleteIcon,
  Edit: MuiEditIcon,
  Email: MuiEmailIcon,
  EmailOutline: MuiEmailOutlineIcon,
  // EmailOff: MdiEmailOffOutlineIcon,
  Error: MuiErrorIcon,
  ExitToApp: MuiExitToAppIcon,
  Facebook: MuiFacebookIcon,
  FilterList: MuiFilterListIcon,
  // FileCSV: MdiFileCSVIcon,
  FileDescription: MuiDescriptionIcon,
  // FileExcel: MdiFileExcelIcon,
  // FilePDF: MdiFilePDFIcon,
  // FilePowerpoint: MdiFilePowerpointIcon,
  // FileWord: MdiFileWordIcon,
  // Folder: IconFolder,
  // Folders: IconFolders,
  // FolderBolt: IconFolderBolt,
  // FolderCancel: IconFolderCancel,
  // FolderCheck: IconFolderCheck,
  // FolderCode: IconFolderCode,
  // FolderCog: IconFolderCog,
  // FolderDown: IconFolderDown,
  // FolderExclamation: IconFolderExclamation,
  // FolderHeart: IconFolderHeart,
  // FolderMinus: IconFolderMinus,
  // FolderOff: IconFolderOff,
  // FolderOpen: IconFolderOpen,
  // FolderPause: IconFolderPause,
  // FolderPlus: IconFolderPlus,
  // FolderSearch: IconFolderSearch,
  // FolderShare: IconFolderShare,
  // FolderStar: IconFolderStar,
  // FolderUp: IconFolderUp,
  // FolderX: IconFolderX,
  // Gavel: IconGavel,
  GetApp: MuiGetAppIcon,
  Help: MuiHelpIcon,
  // History: IconHistory,
  Home: MuiHomeIcon,
  // HourGlass: IconHourglassLow,
  Instagram: MuiInstagramIcon,
  ImportExport: MuiImportExportIcon,
  Info: MuiInfoIcon,
  Label: MuiLabelIcon,
  LabelOff: MuiLabelOffIcon,
  LabelOutline: MuiLabelOutlineIcon,
  LabelOffOutline: MuiLabelOffOutlineIcon,
  LinkedIn: MuiLinkedInIcon,
  Lock: MuiLockIcon,
  // LockQuestion: MdiLockQuestionIcon,
  Menu: MuiMenuIcon,
  More: MuiMoreIcon,
  MoreHoriz: MuiMoreHorizIcon,
  MoreVert: MuiMoreVertIcon,
  Notifications: MuiNotificationsIcon,
  NotificationsOutline: MuiNotificationsOutlineIcon,
  // NotificationsOff: MdiNotificationsOffOutlineIcon,
  Person: MuiPersonIcon,
  Phone: MuiPhoneIcon,
  // Pin: IconPin,
  // Pinned: IconPinned,
  // PinnedOff: IconPinnedOff,
  RadioUnchecked: MuiRadioUncheckedIcon,
  Remove: MuiRemoveIcon,
  Search: MuiSearchIcon,
  Settings: MuiSettingsIcon,
  Sort: MuiSortIcon,
  // Square: IconSquare,
  Star: MuiStarRoundedIcon,
  // SwitchHorizontal: IconSwitchHorizontal,
  // SwitchVertical: IconSwitchVertical,
  Undo: MuiUndoIcon,
  Theaters: MuiTheatersIcon,
  Time: MuiTimeIcon,
  Translate: MuiTranslateIcon,
  Twitter: MuiTwitterIcon,
  Visibility: MuiVisibilityIcon,
  VisibilityOff: MuiVisibilityOffIcon,
  Warn: MuiWarnIcon,
  YouTube: MuiYouTubeIcon,
  // Iconsax
  // ExportCircle: Styled.ExportCircle,
  // ImportCircle: Styled.ImportCircle,
};